import type { PaperInboxFallbackTopicMembershipRow } from './paperInboxApiAdapter';

export interface PaperInboxFallbackProjectRow {
    id: string;
    name: string;
}

export interface PaperInboxFallbackMembershipQueryRow {
    id: string;
    paper_id: string | null;
    project_id: string | null;
}

export interface PaperInboxMatchedTopicsFallbackResolution {
    rows: PaperInboxFallbackTopicMembershipRow[];
    error: Error | null;
}

export function buildPaperInboxFallbackTopicRows(
    rows: PaperInboxFallbackMembershipQueryRow[],
    userProjects: PaperInboxFallbackProjectRow[]
): PaperInboxFallbackTopicMembershipRow[] {
    const projectById = new Map(userProjects.map((project) => [project.id, project]));

    return rows.flatMap((row) => {
        const project = row.project_id ? projectById.get(row.project_id) : null;
        if (!row.paper_id || !project) {
            return [];
        }

        return [{
            id: row.id,
            paper_id: row.paper_id,
            project: {
                id: project.id,
                name: project.name,
            },
        } satisfies PaperInboxFallbackTopicMembershipRow];
    });
}

export function resolvePaperInboxMatchedTopicsFallback<TError>({
    data,
    error,
    userProjects,
    normalizeError,
}: {
    data: PaperInboxFallbackMembershipQueryRow[] | null;
    error: TError | null;
    userProjects: PaperInboxFallbackProjectRow[];
    normalizeError: (error: TError) => Error;
}): PaperInboxMatchedTopicsFallbackResolution {
    if (error) {
        return {
            rows: [],
            error: normalizeError(error),
        };
    }

    return {
        rows: buildPaperInboxFallbackTopicRows(data || [], userProjects),
        error: null,
    };
}
